import $ from 'jquery';

const $header = $( '.c-header' );

if ( $header.length ) {
	$( window ).on( 'scroll', function() {
		const $self = $( this );

		if ( $self.scrollTop() > 0 ) {
			$header.addClass( 'c-header--not-top' );
		} else {
			$header.removeClass( 'c-header--not-top' );
		}
	} );
}
